export default {
  brand: 'USFans Spreadsheet',
  nav_home: 'Strona główna',
  nav_guide: 'Przewodnik',
  nav_shopping_guide: 'Przewodnik zakupowy',
  nav_categories: 'Kategorie',
  nav_article: 'Artykuły',
  nav_faq: 'FAQ',
  nav_safety: 'Bezpieczeństwo',

  hero_eyebrow: 'CENTRUM ZASOBÓW USFANS SPREADSHEET',
  hero_h1: 'USFans Spreadsheet — znajdź lepsze listy, przewodniki i zasoby',
  hero_desc:
    'Poznaj uporządkowane zasoby USFans spreadsheet, przewodniki zakupowe, informacje o sprzedawcach, porady QC, szczegóły wysyłki, recenzje i praktyczne porównania — wszystko w jednym miejscu.',
  hero_cta_main: 'USFans Spreadsheet',
  hero_cta_buy: 'Kup teraz',
  hero_cta_guide: 'Przeczytaj przewodnik',
  hero_trust: 'Niezależne źródło · Regularnie aktualizowane · Wielojęzyczne · Skupione na bezpieczeństwie',

  categories_title: 'Przeglądaj kategorie produktów',
  categories_subtitle: 'Przejdź od razu do kategorii, której szukasz, na głównej witrynie.',
  categories_dropdown_label: 'Wybierz kategorię',
  categories_all: 'Wszystkie kategorie',

  about_eyebrow: 'CZYM JEST USFANS SPREADSHEET?',
  about_title: 'Wszystko, co musisz wiedzieć o USFans Spreadsheet',
  about_desc:
    'Zamiast szukać w rozproszonych informacjach, poznaj uporządkowane centrum zasobów USFans Spreadsheet obejmujące przydatne listy, przewodniki zakupowe, badania sprzedawców, QC, wysyłkę, informacje o magazynie, recenzje, kupony i poradniki bezpieczeństwa.',
  about_cta: 'Poznaj USFans Spreadsheet',

  resources_eyebrow: 'POPULARNE ZASOBY',
  resources_title: 'Popularne zasoby USFans',
  resources_subtitle: 'Zanurz się głębiej dzięki naszym oryginalnym, pomocnym przewodnikom i artykułom.',
  article_card_title: 'USFans Spreadsheet: kompletny przewodnik',
  article_card_desc:
    'Dowiedz się, czym jest arkusz USFans, jak z niego korzystać i jak robić mądrzejsze zakupy dzięki uporządkowanym listom i zasobom.',
  read_more: 'Przeczytaj artykuł',
  read_guide: 'Przeczytaj przewodnik',

  pillars_eyebrow: 'PRZEWODNIKI FILAROWE USFANS',
  pillars_title: 'Pogłębione przewodniki USFans',
  pillars_subtitle:
    'Poznaj nasze oryginalne artykuły filarowe o recenzjach, wysyłce, kuponach, magazynie, bezpieczeństwie i nie tylko.',

  safety_title: 'Czy USFans jest legalny i bezpieczny?',
  safety_desc:
    'Przed skorzystaniem z jakiejkolwiek platformy zakupowej zweryfikuj adres witryny, chroń dane konta, sprawdź metody płatności i bądź ostrożny wobec podejrzanych ofert. Nasze zasoby bezpieczeństwa wyjaśniają praktyczne sposoby ograniczania typowych zagrożeń online.',
  safety_cta: 'Odwiedź Centrum bezpieczeństwa',

  faq_title: 'Często zadawane pytania',
  faq_subtitle: 'Szybkie odpowiedzi na najczęstsze pytania o USFans Spreadsheet.',
  faq_1_q: 'Czym jest USFans Spreadsheet?',
  faq_1_a:
    'USFans Spreadsheet to uporządkowane źródło, które gromadzi linki do produktów, kategorie i szczegóły zakupów w jednym miejscu, pomagając sprawniej przeglądać i porównywać produkty.',
  faq_2_q: 'Gdzie znajdę linki USFans spreadsheet?',
  faq_2_a:
    'Możesz przeglądać kategorie produktów bezpośrednio na tej stronie lub przejść do głównej witryny, aby zobaczyć pełną listę linków i produktów.',
  faq_3_q: 'Czy arkusz USFans jest regularnie aktualizowany?',
  faq_3_a:
    'Tak, jest regularnie odświeżany, aby odzwierciedlać bieżące kategorie i linki. Przed zamówieniem zawsze potwierdź najnowsze informacje na głównej witrynie.',

  final_title: 'Gotowy, by poznać zasoby USFans Spreadsheet?',
  final_desc:
    'Zacznij od kompletnego przewodnika USFans Spreadsheet, poznaj praktyczne zasoby i porównaj ważne informacje, zanim przejdziesz do głównej witryny.',
  final_cta_main: 'Poznaj USFans Spreadsheet',
  final_cta_buy: 'Odwiedź główną witrynę',

  footer_tagline:
    'Niezależne wielojęzyczne centrum zasobów USFans Spreadsheet — oryginalne przewodniki, listy i informacje o bezpieczeństwie.',
  footer_explore: 'Odkrywaj',
  footer_resources: 'Zasoby',
  footer_languages: 'Języki',
  footer_disclaimer:
    'USFansSheet.casa to niezależne źródło informacji i nie jest oficjalnie powiązane ani wspierane przez USFans, chyba że wyraźnie to zaznaczono.',

  back_home: 'Wróć do strony głównej',
  related_article: 'Powiązane zasoby',
  visit_main_site: 'Odwiedź główną witrynę',
  article_not_found: 'Nie znaleziono artykułu',

  category_shoes: 'Buty',
  category_hoodies: 'Bluzy/Swetry',
  category_tshirts: 'T-shirty/Koszulki',
  category_jackets: 'Kurtki',
  category_pants: 'Spodnie/Szorty',
  category_headwear: 'Nakrycia głowy',
  category_sets: 'Zestawy',
  category_underwear: 'Bielizna/Majtki',
  category_jersey: 'Koszulka sportowa',
  category_accessories: 'Akcesoria',
  category_bags: 'Torby',
  category_belts: 'Paski',
  category_perfumes: 'Perfumy',
  category_other: 'Inne rzeczy',
};